export default function ProvaSocial() {
  const depoimentos = [
    {
      nome: 'Carolina Mendes',
      profissao: 'Arquiteta',
      foto: 'https://public.readdy.ai/ai/img_res/159aaea7be608768306e8f86842cce5d.jpg',
      texto: 'Antes do curso eu não sabia nem como explicar meus serviços. Hoje tenho clareza total e minhas vendas triplicaram em 3 meses!',
      resultado: 'Vendas triplicaram'
    },
    {
      nome: 'Ricardo Santos',
      profissao: 'Consultor de Negócios',
      foto: 'https://readdy.ai/api/search-image?query=Professional%20businessman%20confident%20smiling%20portrait%20headshot%2C%20wearing%20business%20shirt%2C%20successful%20appearance%2C%20modern%20corporate%20background%2C%20natural%20professional%20photography%2C%20trustworthy%20presence&width=200&height=200&seq=testimonial-002&orientation=squarish',
      texto: 'O método é realmente prático e direto. Consegui estruturar minha oferta e criar autoridade no Instagram. Os clientes agora me procuram!',
      resultado: 'Clientes o procuram'
    },
    {
      nome: 'Juliana Costa',
      profissao: 'Designer Gráfica',
      foto: 'https://readdy.ai/api/search-image?query=Creative%20professional%20woman%20designer%20smiling%20portrait%20headshot%2C%20casual%20professional%20style%2C%20confident%20happy%20expression%2C%20bright%20modern%20studio%20background%2C%20natural%20photography%2C%20approachable%20demeanor&width=200&height=200&seq=testimonial-003&orientation=squarish',
      texto: 'Finalmente entendi como me posicionar e precificar meus serviços. Dobrei meu ticket médio e ainda consigo escolher meus projetos!',
      resultado: 'Ticket médio dobrou'
    },
    {
      nome: 'Fernando Lima',
      profissao: 'Coach Executivo',
      foto: 'https://readdy.ai/api/search-image?query=Mature%20professional%20businessman%20coach%20mentor%20portrait%20headshot%20smiling%2C%20wearing%20elegant%20suit%2C%20experienced%20confident%20appearance%2C%20executive%20office%20background%2C%20professional%20corporate%20photography&width=200&height=200&seq=testimonial-004&orientation=squarish',
      texto: 'O curso me deu a segurança que eu precisava para investir em tráfego pago. Resultado: agenda sempre cheia e fila de espera!',
      resultado: 'Agenda sempre cheia'
    },
    {
      nome: 'Beatriz Almeida',
      profissao: 'Nutricionista',
      foto: 'https://readdy.ai/api/search-image?query=Healthcare%20professional%20woman%20nutritionist%20smiling%20portrait%20headshot%2C%20white%20coat%2C%20caring%20professional%20expression%2C%20clean%20medical%20office%20background%2C%20natural%20professional%20photography%2C%20trustworthy%20presence&width=200&height=200&seq=testimonial-005&orientation=squarish',
      texto: 'Aprendi a criar conteúdo que atrai pacientes qualificados. Hoje vendo consultorias online e presenciais com facilidade!',
      resultado: 'Vendas online e presenciais'
    },
    {
      nome: 'Pedro Oliveira',
      profissao: 'Fotógrafo',
      foto: 'https://readdy.ai/api/search-image?query=Creative%20professional%20male%20photographer%20portrait%20headshot%20smiling%2C%20casual%20artistic%20style%2C%20confident%20friendly%20expression%2C%20studio%20background%20with%20camera%20equipment%2C%20natural%20photography%2C%20artistic%20presence&width=200&height=200&seq=testimonial-006&orientation=squarish',
      texto: 'O curso transformou minha forma de vender. Antes dependia de indicação, hoje tenho um sistema que gera leads todos os dias!',
      resultado: 'Leads diários'
    }
  ];

  return (
    <section id="depoimentos" className="py-24 bg-gradient-to-b from-purple-50 to-white">
    </section>
  );
}
